export type TWipeRevealRole = "hidden" | "wipe-in" | "shown" | "wipe-out";

export type TWipeRevealTarget = {
	opacity: number;
	maskPosition: string | string[];
	WebkitMaskPosition: string | string[];
};

const MASK_HIDDEN_POSITION = "100% 0%";
const MASK_SHOWN_POSITION = "0% 0%";
const MASK_WIPE_OUT_POSITION = "-100% 0%";

/* Wipe-in restarts from the hidden tail as explicit keyframes rather than animating from
 the current value: after a wipe-out the mask rests at the opposite end of the line, and
 travelling back from there sweeps the reveal across the text in reverse (right-to-left).
 Both ends render the line fully transparent, so restarting at the tail is invisible.
 Targets are module constants so framer-motion's shallow compare never restarts a
 mid-flight wipe on an unrelated re-render. */
const WIPE_REVEAL_TARGETS: Record<TWipeRevealRole, TWipeRevealTarget> = {
	hidden: { opacity: 0, maskPosition: MASK_HIDDEN_POSITION, WebkitMaskPosition: MASK_HIDDEN_POSITION },
	"wipe-in": {
		opacity: 1,
		maskPosition: [MASK_HIDDEN_POSITION, MASK_SHOWN_POSITION],
		WebkitMaskPosition: [MASK_HIDDEN_POSITION, MASK_SHOWN_POSITION],
	},
	shown: { opacity: 1, maskPosition: MASK_SHOWN_POSITION, WebkitMaskPosition: MASK_SHOWN_POSITION },
	"wipe-out": { opacity: 0, maskPosition: MASK_WIPE_OUT_POSITION, WebkitMaskPosition: MASK_WIPE_OUT_POSITION },
};

export function resolveWipeRevealTarget(role: TWipeRevealRole): TWipeRevealTarget {
	return WIPE_REVEAL_TARGETS[role];
}
